"use client"

import * as React from "react"
import { Progress as ProgressPrimitive } from "radix-ui"

import { cn } from "../lib"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<"div"> & {
    value?: number | null
    max?: number
    getValueLabel?(value: number, max: number): string
  }
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn("relative h-4 w-full overflow-hidden rounded-full bg-secondary", className)}
    {...(props as any)}
  >
    <ProgressPrimitive.Indicator
      {...({
        className: "h-full w-full flex-1 bg-primary transition-transform duration-200 ease-out",
        style: { transform: `translateX(-${100 - (value || 0)}%)` },
      } as any)}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
